
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FormLabelProps extends React.ComponentProps<typeof Label> {
  required?: boolean;
  children: React.ReactNode;
}

export const FormLabel = ({ required = false, children, className, ...props }: FormLabelProps) => {
  return (
    <Label 
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="text-destructive ml-1">*</span>}
    </Label>
  );
};
